import { HTMLProps } from "react";

import { clsxMerge } from "shared/lib/helpers";
import { PropsWithClassNameI } from "shared/lib/interfaces/ui";

type RadioButtonElementPropsI = HTMLProps<HTMLInputElement>;

interface RadioButtonPropsI extends PropsWithClassNameI {
  name: string;
  value?: any;
  label: string;
  inputProps?: RadioButtonElementPropsI;
  labelContainerClassName?: string;
  labelClassName?: string;
  variation?: "default" | "medium";
}

const VARIATIONS = {
  MEDIUM: "medium",
};

const DefaultInput = (props: RadioButtonElementPropsI) => <input {...props} />;

const RadioButton =
  (Field = DefaultInput) =>
  // eslint-disable-next-line react/display-name
  ({
    name,
    value,
    label,
    className,
    labelContainerClassName,
    labelClassName,
    inputProps = {},
    variation,
  }: RadioButtonPropsI) => (
    <>
      {VARIATIONS.MEDIUM === variation && (
        <div
          className={clsxMerge(
            "form-control rounded-lg  px-2",
            !className?.includes("border") && "border",
            className
          )}
        >
          <label
            className={clsxMerge(
              "label cursor-pointer justify-start",
              labelContainerClassName
            )}
          >
            <Field
              type="radio"
              name={name}
              value={value}
              className={clsxMerge(
                "radio h-[14px] w-[14px]",
                "transition-[color,border,box-shadow] duration-300",
                "checked:border-[#014DFE] checked:bg-white checked:shadow-[0_0_0_3px_#014DFE_inset,0_0_0_3px_#014DFE_inset]"
              )}
              {...inputProps}
            />

            <span
              title={label}
              className={clsxMerge(
                "ae-typography-button3 text-base-content/60 ml-3",
                labelClassName
              )}
            >
              {label}
            </span>
          </label>
        </div>
      )}

      {!Object.values(VARIATIONS).some((v) => v === variation) && (
        <div
          className={clsxMerge(
            "form-control w-56 rounded-lg px-2",
            !className?.includes("border") && "border",
            className
          )}
        >
          <label
            className={clsxMerge(
              "label cursor-pointer justify-start",
              labelContainerClassName
            )}
          >
            <Field
              type="radio"
              name={name}
              value={value}
              className="radio"
              {...inputProps}
            />

            <span
              title={label}
              className={clsxMerge("label-text ml-4", labelClassName)}
            >
              {label}
            </span>
          </label>
        </div>
      )}
    </>
  );

export default RadioButton;
